export const VERTICAL_KEYS = ["ArrowUp", "ArrowDown"];
export const HORIZONTAL_KEYS = ["ArrowLeft", "ArrowRight"];
export const KEY_INCREMENTS = {
    ArrowUp: -1,
    ArrowDown: 1,
    ArrowLeft: -1,
    ArrowRight: 1,
};
export const isHorizontalKey = (key) => HORIZONTAL_KEYS.includes(key);
export const isVerticalKey = (key) => VERTICAL_KEYS.includes(key);
export const isNavigationKey = (key) => isHorizontalKey(key) || isVerticalKey(key);
export const FOCUSABLE_SELECTOR = [
    "input:not([type=hidden]):not([disabled])",
    "button:not([disabled])",
    "textarea:not([disabled])",
    "a[href]",
    "[tabindex]:not([tabindex='-1']):not([disabled])",
].join(",");
export const getFocusableChildren = (element) => Array.from(element.querySelectorAll(FOCUSABLE_SELECTOR));
export const isFocusable = (element) => element.matches(FOCUSABLE_SELECTOR);
export const getFocusedIndex = (parent) => {
    const focusableChildren = getFocusableChildren(parent);
    return {
        focusableChildren,
        focusedIndex: focusableChildren.indexOf(document.activeElement),
    };
};
//# sourceMappingURL=keyboard.js.map